/* eslint-disable no-console */
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAlzg841VzzTRkQTDF5sRSKz1LXmw5cIxE",
  authDomain: "vpg-app.firebaseapp.com",
  databaseURL: "https://vpg-app.firebaseio.com",
  projectId: "vpg-app",
  storageBucket: "vpg-app.appspot.com",
  messagingSenderId: "379422998157",
  appId: "1:379422998157:web:636e28d6a92a0017efacc4",
  measurementId: "G-K53HTV0QXB",
};
initializeApp(firebaseConfig);
export const messaging = getMessaging();

export const requestForToken = async () => {
  return getToken(messaging, {
    vapidKey:
      "BN0qsHL0_Npf_jcWxeYN6LnL6UxGh6uaZx-F7-l2xPOFhFzJxrlaZe0w8NK1X7964ishwnQvWBn-7I38KVlr4Kw",
  })
    .then((currentToken) => {
      if (currentToken) {
        console.log("current token for client: ", currentToken);
        // Perform any other neccessary action with the token
        return currentToken;
      } else {
        // Show permission request UI
        console.log(
          "No registration token available. Request permission to generate one."
        );
        return null;
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      return null;
    });
};
